import React, { FC, useEffect, useMemo, useState } from "react";
import SmallButton from "../../uikit/atoms/buttons/card/SmallButton";
import classes from "./CompDateContainer.module.scss";
import { userState } from "../../../states/userState";
import { useRecoilValue } from "recoil";
import { backGroundColorCode, foreColor } from "../../../commons/colors";
import TextInputForCard from "../../uikit/atoms/textFields/TextInputForCard";
import { TextField } from "@mui/material";
import {
  colorSelectRuturnCode,
  colorSelectRuturnCodeLite,
} from "../../../commons/columnColor";
import CompleteDatePicker from "../../uikit/atoms/datepickers/CompleteDatePicker";
import { ProcessInfo } from "../RecordDetailForm";

interface CompDateContainerProps {
  completedDay: string;
  shceduledDay: string;
  title: string;
  onChange: (id: string, value: string) => void;
  targetProcess: ProcessInfo;
  scrollToIndex: (index: number) => void;
  index: number;
}

const CompDateContainer: FC<CompDateContainerProps> = (props) => {
  const user = useRecoilValue(userState);
  const {
    completedDay,
    shceduledDay,
    title,
    onChange,
    targetProcess,
    scrollToIndex,
    index,
  } = props;
  //変更の色を保つためのメモ化
  const prevDate = useMemo(
    () => (completedDay !== "" ? new Date(completedDay.replace("F", "")) : ""),
    [title]
  );
  // console.log("completedDay", completedDay);
  const [currentDate, setCurrentDate] = useState<Date | string>(
    completedDay !== "" ? new Date(completedDay.replace("F", "")) : ""
  );
  const [isChanged, setIsChanged] = useState(false);
  //デバッグ用
  // useEffect(() => {
  //   console.log("newDate", currentDate);
  // }, [currentDate]);
  const headerTitle = title.split("_")[1].replace("完了", "");
  const handleClearButtonClick = () => {
    console.log("handleChange");
    setCurrentDate("");
    if (prevDate !== "") {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
    onChange(title, "");
  };
  const inputStyleProcess = (
    name: string,
    color: string,
    isFinished: boolean
  ) => {
    let styles = {
      "&&&": {
        color: `${color}`,
        width: "230px",
        "@media (max-width: 600px)": {
          width: "110px", // デフォルトの幅を110pxに設定
        },
        margin: "0 0 0 0",
        // backgroundColor:"#dedede",
      },
      "& input": {
        paddingTop: 0,
        paddingBottom: 0,
        padding: " 0 2px",
        fontSize: "16px",
        height: "36px",
        color: `${color}`,
        border: `1px solid ${color}`,
        textAlign: "center",
        borderRadius: "5px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "@media (max-width: 600px)": {
          fontSize: "14px", // フォントサイズを14pxに設定
          height: "30px",
        },
      },
      "& .MuiInputBase-input": {
        color: isFinished ? "#00556f" : `${color}`, // 入力文字の色
        backgroundColor: isFinished
          ? "#b3fea1"
          : backGroundColorCode(user?.mode ?? "lite"),
      },
      "& label": {
        fontSize: "14px",
        color: `${color}`, // 通常時のラベル色
        "@media (max-width: 600px)": {
          fontSize: "12px", // フォントサイズを14pxに設定
        },
        //backgroundColor:"white"
      },
      "& label.Mui-focused": {
        color: `${color}`, // ラベルの色`${color}`指定
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: `${color}`, // 通常時のボーダー色
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: `${color}`, // ホバー時のボーダー色
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: `${color}`, // 通常時のボーダー色(アウトライン)
        },
        "&:hover fieldset": {
          borderColor: `${color}`, // ホバー時のボーダー色(アウトライン)
        },
      },
    };
    styles["&&&"].width = "80px";
    styles["&&&"]["@media (max-width: 600px)"] = { width: "80px" };

    return styles;
  };
  return (
    <div
      className={classes.root}
      style={{
        ...foreColor(user?.mode ?? "lite"),
        backgroundColor: isChanged ? "yellow" : "inherit",
      }}
    >
      <div className={classes.header}>
        <div className={classes.title}>{headerTitle}</div>
        <div className={classes.button}>
          <SmallButton
            label={"C"}
            disabled={false}
            width={"30px"}
            onClick={handleClearButtonClick}
            colorStyle={"noColor"}
          />
        </div>
      </div>
      <div className={classes.days}>
        <div className={classes.schedule}>
          <TextField
            label={"予定日"}
            variant="outlined"
            value={shceduledDay}
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            sx={inputStyleProcess(
              "none",
              user?.mode === "lite"
                ? colorSelectRuturnCodeLite("PT_")
                : colorSelectRuturnCode("PT_"),
              false
            )}
            multiline={false}
            // helperText={errorWorkerName.text}
            // disabled={isDisabled}
            // error={errorWorkerName.isShow}
          />
        </div>
        <div className={classes.complete}>
          <CompleteDatePicker
            currentDate={currentDate}
            setCurrentDate={setCurrentDate}
            disabled={false}
            label={"完了日"}
            isChanged={isChanged}
            setIsChanged={setIsChanged}
            onChange={onChange}
            title={title}
            targetProcess={targetProcess}
            scrollToIndex={scrollToIndex}
            index={index}
          />
        </div>
      </div>
    </div>
  );
};

export default CompDateContainer;
